import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const services = [
  {
    code: 'UI',
    title: 'Premium Web Design',
    desc: 'Modern layouts, bold colors, smooth spacing, and responsive pages that make a brand look trustworthy from the first scroll.',
    tag: 'Design',
    accent: 'var(--aqua)',
  },
  {
    code: 'DEV',
    title: 'Web Development in Chennai',
    desc: 'Clean HTML, CSS, JavaScript, React, PHP, and WordPress builds for startups, local businesses, and personal brands in Chennai and India.',
    tag: 'Build',
    accent: 'var(--rose)',
  },
  {
    code: 'FLT',
    title: 'Flutter App Development',
    desc: 'Mobile app UI and Flutter development support for Android and iOS ideas, prototypes, business tools, and client-ready app experiences.',
    tag: 'Apps',
    accent: 'var(--lime)',
  },
  {
    code: 'NET',
    title: '.NET Web Solutions',
    desc: 'Practical .NET web project support for business systems, admin panels, internal tools, and structured application workflows.',
    tag: 'Backend',
    accent: 'var(--violet)',
  },
  {
    code: 'CMS',
    title: 'WordPress Websites',
    desc: 'Business websites, restaurant pages, landing pages, and portfolio sites that are easy to update and ready for launch.',
    tag: 'CMS',
    accent: 'var(--sun)',
  },
  {
    code: 'APP',
    title: 'Dashboard Interfaces',
    desc: 'Sharp UI screens for admin panels, SaaS tools, CRM ideas, and internal products with clean information hierarchy.',
    tag: 'Interface',
    accent: 'var(--aqua)',
  },
  {
    code: 'SEO',
    title: 'Performance Polish',
    desc: 'Image handling, layout fixes, accessibility basics, metadata cleanup, and speed-minded improvements for better user experience.',
    tag: 'Optimize',
    accent: 'var(--rose)',
  },
  {
    code: 'DATA',
    title: 'Excel and Reports',
    desc: 'Simple dashboards, formulas, reporting sheets, and organized data tools for daily business operations.',
    tag: 'Productivity',
    accent: 'var(--sun)',
  },
];

function ServiceCard({ service, index, inView }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 32 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.55, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ y: -8 }}
      className="premium-card shine"
      style={{
        padding: 28,
        minHeight: 300,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 18, marginBottom: 28 }}>
        <div
          style={{
            width: 58,
            height: 58,
            borderRadius: 8,
            display: 'grid',
            placeItems: 'center',
            background: `linear-gradient(135deg, ${service.accent}, rgba(255,255,255,0.12))`,
            color: 'var(--ink)',
            fontFamily: 'var(--font-display)',
            fontSize: 15,
            fontWeight: 800,
          }}
        >
          {service.code}
        </div>
        <span className="chip" style={{ color: service.accent }}>{service.tag}</span>
      </div>

      <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 22, lineHeight: 1.18, marginBottom: 14 }}>
        {service.title}
      </h3>
      <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.75, marginBottom: 24 }}>{service.desc}</p>
      <div style={{ marginTop: 'auto', height: 3, width: 90, borderRadius: 8, background: `linear-gradient(90deg, ${service.accent}, transparent)` }} />
    </motion.article>
  );
}

export default function Services() {
  const [ref, inView] = useInView({ threshold: 0.05, triggerOnce: true });

  return (
    <section id="service" ref={ref} className="section-pad alt">
      <div className="ghost-text">SERVICES</div>

      <div className="section-shell">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          style={{ textAlign: 'center', marginBottom: 58 }}
        >
          <div className="eyebrow" style={{ justifyContent: 'center' }}>What I offer</div>
          <h2 className="section-title">Services for brands that need a stronger screen presence.</h2>
        </motion.div>

        <div className="services-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 18 }}>
          {services.map((service, index) => <ServiceCard key={service.title} service={service} index={index} inView={inView} />)}
        </div>
      </div>

      <style>{`
        @media (max-width: 1180px) { .services-grid { grid-template-columns: 1fr 1fr !important; } }
        @media (max-width: 660px) { .services-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}
